import MuiChip, { ChipProps as MuiChipProps } from '@mui/material/Chip';

import { ChipSkeleton } from './ChipSkeleton';
import React from 'react';
import { pxToRem } from 'src/common/utils/fonts';

export type ChipProps = {
  color?: MuiChipProps['color'];
  size?: MuiChipProps['size'];
  variant?: MuiChipProps['variant'];
  label?: string;
  onDelete?: MuiChipProps['onDelete'];
  icon?: MuiChipProps['icon'];
  isLoading?: boolean;
};

export const Chip: React.FC<ChipProps> = ({
  color = 'default',
  size = 'medium',
  variant = 'outlined',
  label = '',
  onDelete,
  icon,
  isLoading,
}) => {
  return (
    <>
      {isLoading ? (
        <ChipSkeleton />
      ) : (
        <MuiChip
          label={label}
          variant={variant}
          color={color}
          size={size}
          onDelete={onDelete}
          icon={icon}
          sx={{
            gap: 1,
            '&:has(> svg:first-of-type + span) > svg:first-of-type': {
              width: pxToRem(14),
              height: pxToRem(14),
              ml: '-3 !important',
              mr: 0,
            },
            '& .MuiChip-label': {
              mt: 1,
            },
            '& .MuiChip-deleteIcon': {
              width: pxToRem(20),
              height: pxToRem(20),
            },
          }}
        />
      )}
    </>
  );
};
